import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query SkillDirectoryForTransfer($directoryId: ID!, $channelIdentifier: String!, $channelId: ID!) {
  requestTypeDirectoryForTransfer(id: $directoryId) {
    id
    name
    commonOperatorsCounter(channelId: $channelId)
    requestTypes {
      activitiesCounter(channelId: $channelId)
      operatorsCounter(channelId: $channelId)
      priority
      availableOperators(channelId: $channelId, channelIdentifier: $channelIdentifier) {
        id
        fullName
      }
      requestType {
        id
        name
        active
        description
      }
    }
  }
}`;

function getSkillDirectoryForTransfer({
  directoryId,
  channelIdentifier,
  channelId,
}) {
  return apollo.client.query({
    query,
    variables: {
      directoryId,
      channelIdentifier,
      channelId,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.requestTypeDirectoryForTransfer);
}

export default getSkillDirectoryForTransfer;
